<template>
<div class="mcontainer">
  <van-nav-bar fixed :title="title" left-text="返回" left-arrow @click-left="$utils.jump('/?type=2')" />
  <div class="main__body">
    <div class="input__wrapper" v-if="detail!=null">
      <van-cell-group title="基本信息（必填）">
        <van-field required v-model="input.name" :readonly="readonly" label="意愿人姓名：" placeholder="意愿人姓名" />
        <van-field required v-model="input.tel" :readonly="readonly" type="number" label="电话：" placeholder="电话" />
        <van-field required v-model="areaFormate" :readonly="readonly" label="请选择区域：" type="textarea" placeholder="点击选择地区" autosize readonly @click="showArea" rows="1" />
        <van-field required v-model="input.block" :readonly="readonly" type="number" label="楼栋号：" placeholder="楼栋号" />
        <van-field required v-model="input.unit" :readonly="readonly" type="number" label="单元号：" placeholder="单元号" />
        <van-field required v-model="input.floor" :readonly="readonly" type="number" label="所在楼层：" placeholder="所在楼层" />
        <van-field required v-model="input.room" :readonly="readonly" type="number" label="房号：" placeholder="房号" />
      </van-cell-group>
      <van-cell-group title="辅助信息（选填）">
        <van-field v-model="input.families" :readonly="readonly" label="总户数：" placeholder="总户数" />
        <van-field v-model="input.apply_families" :readonly="readonly" type="number" label="申请户数：" placeholder="申请户数" />
        <van-field v-model="input.apply_num" :readonly="readonly" type="number" label="加装数量：" placeholder="加装数量" />
        <van-field v-model="input.structure" :readonly="readonly" label="房屋结构：" placeholder="房屋结构" />
        <van-field v-model="input.build_time" :readonly="readonly" label="建成时间：" placeholder="建成时间" />
        <van-field v-model="input.total_floor" :readonly="readonly" type="number" label="总楼层：" placeholder="总楼层" />
      </van-cell-group>
      <van-cell-group title="是否志愿成为加装联络人">
        <van-field name="switch" v-if="typeof id=='undefined'">
          <template #input>
            <van-switch v-model="input.is_contact" size="20" />
          </template>
        </van-field>
        <p class="m__field" v-else>{{input.is_contact==1?'是':'否'}}</p>
      </van-cell-group>
      <van-cell-group title="验证" v-if="typeof id=='undefined'">
        <div class="vercode__wrapper clearfix">
          <div class="vercode__input">
            <van-field v-model="verCode" placeholder="请输入验证码" label="验证码" class="vercode" maxlength="4" />
          </div>
          <div class="vercode__img" @click="changeCode">
            <img :src="verCodeUrl">
          </div>
        </div>
      </van-cell-group>
      <van-cell-group title="处理结果" v-if="typeof id!='undefined'">
        <van-field v-model="input.status_name" label="处理状态：" readonly />
        <van-field v-model="input.replay" type="textarea" label="处理回复：" autosize readonly />
      </van-cell-group>
      <div class="btn__wrapper" v-if="typeof id=='undefined'">
        <van-button type="info" size="large" @click="sub">提交</van-button>
      </div>
    </div>
  </div>
  <van-popup v-model="areaShow" position="bottom" round>
    <van-picker show-toolbar :columns="columns" @change="onChange" title="选择区域" @cancel="areaShow=false" @confirm="onConfirm" :loading="loading" />
  </van-popup>
</div>
</template>
<script>
import {
  mapActions
} from 'vuex'
export default {
  components: {},
  data() {
    return {
      input: {},
      areaShow: false,
      columns: [],
      area: [], //区域
      street: [], //街道
      community: [], //社区
      family: [], //小区
      choose: [],
      loading: true,
      areaFormate: '',
      readonly: true,
      title: '加装意愿登记',
      verCode: '',
      verCodeUrl: '',
      detail: null
    }
  },
  props: [],
  computed: {
    id() {
      return this.$route.query.id
    }
  },
  watch: {},
  created() {
    this.verCodeUrl = window.g.vercodeUrl
    let {
      id
    } = this
    if (typeof id != 'undefined') {
      this.title = '加装意愿查看'
      this.readonly = true
      this.getApply()
    } else {
      this.detail = {}
      this.readonly = false
    }
    this.initArea()
  },
  mounted() {},
  destroyed() {},
  methods: {
    changeCode() {
      this.verCodeUrl = window.g.vercodeUrl + '?' + Math.random()
    },
    showArea() {
      let {
        id
      } = this
      if (typeof id == 'undefined') {
        this.areaShow = true
      }
    },
    checkInput(input, checkList) {
      let err = 0
      for (let i = 0; i < checkList.length; i++) {
        let checkItem = $.trim(input[checkList[i]])
        if (checkItem == '' || typeof checkItem == 'undefined') {
          err = 1
          break
        }
      }
      if (err == 0) {
        return true
      } else {
        return false
      }
    },
    onConfirm(values, index) {
      this.areaShow = false
      this.choose = index
      let {
        area,
        street,
        community,
        family,
        choose
      } = this
      let area_1 = area[choose[0]].name
      let area_2 = street[choose[1]].name
      let area_3 = community[choose[2]].name
      let area_4 = family[choose[3]].name
      this.areaFormate = area_1 + ',' + area_2 + ',' + area_3 + ',' + area_4
    },
    async initArea() {
      this.loading = true
      await this.getArea()
      await this.getArea(this.area[0].id, 1)
      await this.getArea(this.street[0].id, 2)
      await this.getArea(this.community[0].id, 3)
      let col = [{
        values: this.formatData(this.area)
      }, {
        values: this.formatData(this.street)
      }, {
        values: this.formatData(this.community)
      }, {
        values: this.formatData(this.family)
      }]
      this.columns = col
      this.loading = false
    },
    async onChange(picker, values, index) {
      this.loading = true
      let self = this
      let colIndex = picker.getIndexes()
      switch (index) {
        case 0:
          await self.getArea(self.area[colIndex[index]].id, index + 1)
          await self.getArea(self.street[0].id, 2)
          await self.getArea(self.community[0].id, 3)
          picker.setColumnValues(index + 1, self.formatData(self.street))
          picker.setColumnValues(index + 2, self.formatData(self.community))
          picker.setColumnValues(index + 3, self.formatData(self.family))
          break;
        case 1:
          await self.getArea(self.street[colIndex[index]].id, index + 1)
          await self.getArea(self.community[0].id, 3)
          picker.setColumnValues(index + 1, self.formatData(self.community))
          picker.setColumnValues(index + 2, self.formatData(self.family))
          break;
        case 2:
          await self.getArea(self.community[colIndex[index]].id, index + 1)
          picker.setColumnValues(index + 1, self.formatData(self.family))
          break;
      }
      this.loading = false
    },
    async getArea(fid = 0, level = 0) {
      let self = this
      let {
        id
      } = self
      let posData = {
        data: {
          fid
        },
        loadMsg: false
      }
      let res = await this._getArea(posData)
      if (res && res.code == 200) {
        switch (level) {
          case 0:
            self.area = res.data
            break;
          case 1:
            self.street = res.data
            break;
          case 2:
            self.community = res.data
            break;
          case 3:
            self.family = res.data
            break;
        }
      }
    },
    async sub() {
      let self = this
      let {
        input,
        choose,
        family,
        areaFormate,
        verCode
      } = self
      let check = this.checkInput(input, ['name', 'tel', 'block', 'unit', 'floor','room'])
      if (!check) {
        this.$utils.toast('请填写完整', 'err')
        return false
      }
      if ($.trim(verCode) == '') {
        this.$utils.toast('请填写验证码', 'err')
        return false
      }
      if (areaFormate != '') {
        input.area_id = family[choose[3]].id
      } else {
        this.$utils.toast('请选择区域', 'err')
        return false
      }
      input.verCode = verCode
      let posData = {
        data: input
      }
      let userInfo = self.$utils.getStorage('userInfo')
      if (userInfo != null) {
        posData.auth = true
      }
      if (input.is_contact != true) {
        this.$dialog.confirm({
            title: '提示',
            message: '是否志愿成为本单元电梯加装联络员？',
          })
          .then(() => {
            posData.data.is_contact = true
            self.actSub(posData)
          })
          .catch(() => {
            self.actSub(posData)
          })
      } else {
        self.actSub(posData)
      }
    },
    async actSub(posData) {
      let self = this
      let res = await self._subApply(posData)
      if (res && res.code == 200) {
        if (typeof res.data != 'undefined') {
          self.$dialog({
            title: '提交成功',
            message: '请使用查询代码查询本次提交结果：' + res.data
          }).then(() => {
            self.$utils.jump('/?type=2')
          })
          return false
        }
        self.$utils.toast('提交成功')
        setTimeout(() => {
          self.$utils.jump('/?type=2')
        }, 2000)
      } else {
        self.verCodeUrl = window.g.vercodeUrl + '?' + Math.random()
      }
    },
    async getApply() {
      let {
        id
      } = this
      let posData = {
        data: {
          id: id
        }
      }
      let res = await this._getApply(posData)
      if (res && res.code == 200) {
        let resData = res.data
        resData.is_contact = resData.is_contact == 0 ? false : true
        this.input = resData
        this.detail = resData
        this.areaFormate = resData.path_all
        if ($.trim(resData.remarks) == '' || resData.remarks == null) {
          this.input.remarks = '无'
        }
      }
    },
    formatData(data) {
      let newData = []
      for (let i = 0; i < data.length; i++) {
        newData.push(data[i].name)
      }
      return newData
    },
    ...mapActions('api', ['_getArea', '_subApply', '_getApply'])
  }
}
</script>
<style lang="less" scoped>
.mcontainer {
    .main__body {
        margin-top: 46px;
        .m__field {
            padding: 10px 16px;
            color: #323233;
            font-size: 14px;
            line-height: 24px;
            margin: 0;
        }
    }
}
</style>
